import type {
  AdminTenantFeaturesFieldsFragment,
  FeatureFlagName,
  SetAdminTenantFeaturesMutation,
  SetTenantFeaturesInput,
} from './graphql';

export type TenantFeatures = AdminTenantFeaturesFieldsFragment;
export type TenantFeatureFlag = TenantFeatures['flags'][number];
export type OwnSetting = NonNullable<TenantFeatureFlag['ownSetting']>;
export type TenantFeaturesSaveResult = SetAdminTenantFeaturesMutation['setAdminTenantFeatures'];

export const TENANT_FEATURES_CONFLICT = 'TENANT_FEATURES_CONFLICT';

export const isTenantFeaturesConflict = (result: TenantFeaturesSaveResult): boolean =>
  !!result.errors?.some((error) => error.code === TENANT_FEATURES_CONFLICT);

export const listedFlags = (input: SetTenantFeaturesInput): Set<FeatureFlagName> =>
  new Set(input.settings.map((setting) => setting.name));

export const sameOwnSetting = (
  a: OwnSetting | null | undefined,
  b: OwnSetting | null | undefined
): boolean =>
  (a?.mode ?? null) === (b?.mode ?? null) && (a?.config ?? null) === (b?.config ?? null);

export const mergeSavedFeatures = (
  baseline: TenantFeatures,
  saved: TenantFeatures,
  listed: ReadonlySet<FeatureFlagName>
): TenantFeatures => ({
  ...baseline,
  workSuiteProductIds: [...saved.workSuiteProductIds],
  flags: baseline.flags.map((flag) => {
    const savedFlag = saved.flags.find((candidate) => candidate.name === flag.name);
    if (!savedFlag) return flag;
    if (listed.has(flag.name)) return savedFlag;
    // An unlisted own setting in a save's response comes from a read model that can lag the save.
    return sameOwnSetting(savedFlag.ownSetting, flag.ownSetting)
      ? { ...savedFlag, ownSetting: flag.ownSetting }
      : flag;
  }),
});
